export default "__VITE_ASSET__BkuXKrvM__"